import styled, { css } from 'styled-components';

export const ContainerCheckBox = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    @media (max-width: 1200px) {
        align-items: flex-start;

        & span {
            margin-top: 0;
        }
    }
`;

export const CheckBox = styled.input`
  width: 16px;
  height: 16px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.surface.high};
  border: 1px solid ${({ theme }) => theme.colors.border};
  cursor: pointer;
  margin: 0;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const TextInfo = styled.span`
`;

export const TextInfoBold = styled.span<{ $disabledText: boolean }>`
    font-family: Inter;
    font-size: 14px;
    line-height: 16.94px;
    text-align: left;
    margin-top: 2px;
    font-weight: 600;
    margin: 2px 4px 0 8px;

    ${({ $disabledText, theme }) => $disabledText && css`
        color: ${theme.colors.button.text.disabled};
    `}

    @media screen {
        white-space: nowrap;
    }
`;
